import React, {Fragment} from 'react'

import BreedsList from './BreedsList'
import BreedsDetails from './BreedsDetails'
import {includes} from 'lodash';
import { useTranslation } from 'react-i18next';
import { currentLang } from '../../utils/functions';
import { siteInfo } from './../../utils/config';

const Breeds = ({match}) => {
	const {t} = useTranslation();
	//const animals = ['koe', 'varken', 'lam', 'kalkoen', 'hert', 'kip'];
	const animals = siteInfo[currentLang()]['animal_types'];
	let {slug, page} = match.params;
	let filter = 'cow';
	let detailPage = true;
	//console.log(slug, t(slug), animals);
	if(slug){
		if(parseInt(slug) > 0){
			//console.log(11);
			page = slug;
			detailPage = null;
		}
		if(includes(animals, t(slug))){
			//console.log(slug);
			filter=t(slug);
			detailPage = null;
		}

	}else{
		detailPage = null;
	}

	//console.log(slug, page, filter, detailPage);


	if(detailPage){
		filter = page;
		return (
			<Fragment>
				<BreedsDetails slug={slug} animal={filter} />
			</Fragment>
		)
	}else{
		return (
			<Fragment>
				<BreedsList page={page} filter={filter} />
			</Fragment>
		)
	}
}

export default Breeds
